import { useCallback } from 'react';
import { usePayment } from '../context';
import {
  buildAssertionOptions,
  extractAssertionResponse,
  getWebAuthnErrorMessage,
} from '../services/webauthn';
import type { AssertionResponse } from '../services/webauthn';

export function useWebAuthnAssertion(): () => Promise<AssertionResponse | null | undefined> {
  const { data, dispatch } = usePayment();

  return useCallback(async (): Promise<AssertionResponse | null | undefined> => {
    if (!window.PublicKeyCredential) {
      dispatch({
        type: 'SET_ERROR',
        errorMessage: 'Seu navegador não suporta autenticação biométrica.',
      });
      return null;
    }

    const assertionOptions = data.assertionOptions;
    if (!assertionOptions) {
      dispatch({ type: 'SET_ERROR', errorMessage: 'Opções de autenticação não disponíveis.' });
      return null;
    }

    try {
      const publicKeyOptions = buildAssertionOptions(assertionOptions);
      const credential = (await navigator.credentials.get({
        publicKey: publicKeyOptions,
      })) as PublicKeyCredential | null;

      if (!credential) {
        throw new Error('WebAuthn assertion returned no credential');
      }

      return extractAssertionResponse(credential);
    } catch (err: unknown) {
      const errorMessage = getWebAuthnErrorMessage(err as Error);
      dispatch({ type: 'SET_ERROR', errorMessage });
      return null;
    }
  }, [data.assertionOptions, dispatch]);
}
